import { render, staticRenderFns } from "./ChangeLogsView.vue?vue&type=template&id=f38af21e&scoped=true&"
import script from "./ChangeLogsView.vue?vue&type=script&lang=js&"
export * from "./ChangeLogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38af21e",
  null
  
)

export default component.exports